import {
	COMPOSED_OF,
} from '~/scripts/constants/common-kids';
import Relation from './model/relation';

export const ignoreRelations = new Set([
	COMPOSED_OF,
]);

export default {
	/**
	 * @type {(import('./model/node').default)[]}
	 */
	relations: [],

	/**
	 * @param {import('angular').auto.IInjectorService} $injector
	 * @returns {Promise<(import('./model/node').default)[]>}
	 */
	async get($injector) {
		if (this.relations.length > 0) {
			return this.relations;
		}
		const NodeService = $injector.get('NodeService');
		const relations = await NodeService.list('K_NODE;RELATION');
		this.relations = relations.map((/** @type {any} */ relation) => new Relation(relation));
		return this.relations;
	},
};
